<template>
  <DsDocumentationSection
    tag="Documentación"
    title="Lo que necesitarás para tu proceso"
    title-id="avaluos-documentation-title"
    description="Reuné esta documentación para que tu proceso avance sin contratiempos."
    :image="documentationImage"
    image-alt="Sala de una vivienda con mobiliario y plantas"
    :items="documentationItems"
    class="avaluos-documentation"
  />
</template>

<script setup lang="ts">
import documentationImage from '../../../../../assets/avaluos/avaluos-documentation.webp'
import documentIcon from '../../../../../assets/avaluos/avaluos-document.svg'
import paymentIcon from '../../../../../assets/avaluos/avaluos-payment.svg'
import propertyIcon from '../../../../../assets/avaluos/avaluos-property.svg'
import DsDocumentationSection from '../components/DsDocumentationSection.vue'

const documentationItems = [
  {
    id: 'hircasa-documents',
    iconSrc: documentIcon,
    text:
      'Documentos de HIR Casa: Carta autorización y solicitud ' +
      '(proporcionadas por HIR Casa)'
  },
  {
    id: 'process-payment',
    iconSrc: paymentIcon,
    text: 'Pago del trámite: Previamente te enviamos tu cotización'
  },
  {
    id: 'property-documents',
    iconSrc: propertyIcon,
    text:
      'Del inmueble: Boleta de agua, predial y título de propiedad del ' +
      'inmueble a valuar'
  }
]
</script>

<style scoped>
.avaluos-documentation :deep(.ds-documentation-section__media) {
  aspect-ratio: 1 / 1;
}

.avaluos-documentation :deep(.ds-documentation-section__content) {
  width: calc(100% - 16px);
  margin-right: 8px;
  margin-left: 8px;
}

@media (min-width: 768px) {
  .avaluos-documentation :deep(.ds-documentation-section__media) {
    height: 460px;
    aspect-ratio: auto;
  }

  .avaluos-documentation :deep(.ds-documentation-section__content) {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  .avaluos-documentation :deep(.ds-documentation-section__image) {
    object-position: left center;
  }
}

@media (min-width: 1208px) {
  .avaluos-documentation :deep(.ds-documentation-section__media) {
    height: 454px;
  }
}
</style>
